export const IDLE = "idle"
export const LOADING = "loading"